export const removeEmpty = (object = {}) =>
  Object.keys(object).reduce(
    (acc, key) => (object[key] ? { ...acc, [key]: object[key] } : acc),
    {}
  );
